<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"   :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import Url from '@/views/crs36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import Qs from 'qs'
  export default {
    name: 'user',
    components: {
      tablePage,
      FORM,
    },
    methods: {
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('crs36.bt.search') == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }
      },
    },
    data () {
      return {
        queryData:{},
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            { title: "活动ID", field: 'luckyDrawId'},
            { title: "用户账号", field: 'account'},
            {click: window.$t('crs36.bt.search')},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.luckyDraw.black.query, //请求路径和参数
          sequence: true,
          cols: [
              { title: "活动ID", field: 'luckyDrawId'},
              { title: "用户账号", field: 'account'},
              { title: "更新人", field: 'updater'},
              { title: "更新时间", field: 'updateDate'},
          ],
        },
      }
    }
  }
</script>
/**
* 抽奖活动id（条件所属活动，t_lucky_draw id）
*/
@TableField("`lucky_draw_id`")
private Integer luckyDrawId;
/**
* 用户账号
*/
private Integer account;
/**
* 更新者
*/
@TableField(fill = FieldFill.INSERT_UPDATE)
private Long updater;
/**
* 更新时间
*/
@TableField(fill = FieldFill.INSERT_UPDATE,value = "update_date")
private Date updateDate;
